import React from 'react';
type TooltipProps = {
  label: string;
  position?: 'top' | 'bottom';
  children: React.ReactNode;
};
const Tooltip = ({
  label,
  position = 'top',
  children
}: TooltipProps) => <span className="relative inline-block group" data-id="element-1046" data-mp="ywt5hptn3m45">
    <span className="cursor-help border-b border-dotted border-gray-400" data-id="element-1047" data-mp="yw07pecns6y5">
      {children}
    </span>
    <span role="tooltip" className={`pointer-events-none invisible absolute left-1/2 z-50 w-56 max-w-[14rem] -translate-x-1/2 whitespace-normal break-words rounded-lg bg-gray-900 px-3 py-2 text-left text-xs font-medium normal-case leading-relaxed tracking-normal text-white opacity-0 shadow-xl transition-opacity duration-150 group-hover:visible group-hover:opacity-100 ${position === 'top' ? 'bottom-full mb-2' : 'top-full mt-2'}`} data-id="element-1048" data-mp="13ul5l74fuejf">
      {label}
    </span>
  </span>;
export default Tooltip;